import {
  EMPLOYEE_CONTRACT_DAILY_FETCHING,
  EMPLOYEE_CONTRACT_DAILY_SUCCESS,
  EMPLOYEE_CONTRACT_DAILY_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_CONTRACT_DAILY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_CONTRACT_DAILY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_CONTRACT_DAILY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
